import BotConditionCard from "./BotConditionCard";
import React from "react";
import {useWatch} from "react-hook-form";
import ReactHookFormCheckbox from "../../input/ReactHookFormCheckbox";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import ISPMultiSelect from "../../campaigns/conditions/ISPMultiSelect";
import {Add, Delete} from "@mui/icons-material";
import {Box, Button, IconButton} from "@mui/material";

function BotConditionISP(props) {
    // 1. Receive control, setValue and unregister from props
    const {control, setValue, getValues} = props;

    // 2. Watch the rules object directly from the parent form in real-time
    const rules = useWatch({control, name: "rules"}) || {};

    // 3. Check directly if the 'isp' key exists in the rules object (No indexes!)
    const ispData = rules?.isp;
    const hasIspCondition = !!ispData;

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
    ];

    // 4. REMOVE: Unregister the 'rules.isp' path to completely delete it from the form object
    const removeCondition = () => {
        const currentRules = {...getValues("rules")};
        delete currentRules?.isp; // Completely deletes the 'isp' property
        setValue("rules", currentRules); // Triggers re-render with clean object
    };

    // 5. ADD: Use setValue to initialize the flat 'isp' object directly under rules
    const addCondition = () => {
        setValue("rules.isp", {
            condition: "is",
            includeEmptyValue: false,
            values: []
        });
    };

    const renderAddCondition = () => {
        if (!hasIspCondition) {
            return (
                <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                    <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                        <span>ISP</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            onClick={addCondition}
                            sx={{textTransform: "none", py: 0.25, px: 1}}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        if (hasIspCondition) {
            return (
                <>
                    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                        <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                            ISP
                        </Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size="small"
                                onClick={removeCondition}
                                sx={{color: 'error.dark'}}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        {/* Bind the name directly to the clean rules.isp path */}
                        <ReactHookFormRadio
                            control={control}
                            options={radioConditions}
                            name="rules.isp.condition"
                            label="conditions"
                        />
                    </Box>
                    <Box>
                        <ReactHookFormCheckbox
                            control={control}
                            label="Include empty value"
                            labelPlacement="end"
                            name="rules.isp.includeEmptyValue"
                        />
                    </Box>
                    <Box>
                        <ISPMultiSelect
                            control={control}
                            inputName="rules.isp.values"
                            inputLabel="Select or search for ISP"
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <BotConditionCard>
            {renderAddCondition()}
            {renderConditionBox()}
        </BotConditionCard>
    );
}

export default BotConditionISP;
